<template>
    <div>
        <div class="service-mortgage__slider swiper-container">
            <div class="swiper-wrapper">
                <a
                    v-for="(item, index) in items" :key="index"
                    :href="item.attributes[0].url"
                    class="blog__card swiper-slide _mb-0-16"
                >
                    <p class="blog__card-date p4 _position-relative">{{ item.attributes[0].pubDate }}</p>
                    <h3 class="h3 _mt-16 _position-relative">{{ item.attributes[0].name }}</h3>
                </a>
            </div>
            <div class="swiper-pagination _desktop-hidden"></div>
        </div>
        <a :href="buttonLink" class="button button_gray-light _mt-32-16">{{ buttonText }}</a>
    </div>
</template>

<script>
    import { ref, onBeforeMount, onUpdated } from 'vue';
    import Swiper from 'swiper';
    import axios from 'axios';

    export default {
        name: 'ArticlesRedesign',
        props: {
            articlesUrl: {
                type: String,
                default: ''
            },
            buttonText: {
                type: String,
                default: 'Все статьи'
            },
            buttonLink: {
                type: String,
                default: ''
            }
        },
        setup(props) {
            let items = ref([]);

            const initStepsSlider = () => {
                const config = {
                    slidesPerView: 'auto',
                    centeredSlides: false,
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        allowTouchMove: true,
                        dynamicBullets: true,
                        dynamicMainBullets: 2
                    }
                }

                let stepsSlider = new Swiper('.service-mortgage__slider', config);

                window.addEventListener('orientationchange', () => {
                    if (stepsSlider && stepsSlider instanceof Swiper) {
                        stepsSlider.destroy(true, true);

                        setTimeout(() => {
                            stepsSlider = new Swiper('.service-mortgage__slider', config);
                        }, 100);
                    }
                });
            }

            const removeExcessArticles = () => {
                items.value = items.value.slice(0, 3);
            }

            const fixPubDate = () => {
                items.value = items.value.map((val) => {
                    val.attributes[0].pubDate = val.attributes[0].pubDate.slice(0, 10);
                    return val;
                })
            }
            
            onBeforeMount(() => {
                axios.get(props.articlesUrl, { headers: {'Accept': 'application/vnd.api+json'} })
                    .then((response) => {
                            items.value = response.data.data;
                            removeExcessArticles();
                            fixPubDate();
                            initStepsSlider();
                        }
                    )
            })

            onUpdated(() => {
                initStepsSlider();
            })

            return {
                items,
                initStepsSlider,
                removeExcessArticles
            }
        }
    }
</script>

<style scoped lang="scss">
    @import '../../assets/scss/base/_variables.scss';
    @import '../../assets/scss/base/_mixins.scss';
    @import '../../assets/scss/base/_functions.scss';

    .blog__card {
        @include fluid('max-width', 383px);

        @include mobile {
            max-width: 100%;
        }
    }
</style>
